import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
export function FAQ() {
  const faqs = [{
    q: '¿Cómo recibo el material?',
    a: 'Al confirmar el pago recibís un email con acceso inmediato a todos los PDFs. Descargalos y empezá hoy mismo.'
  }, {
    q: '¿Sirve si soy profe nuevo o si tengo experiencia?',
    a: 'Sí. El sistema está diseñado para ambos perfiles. El profe nuevo tiene la estructura que necesita para empezar con confianza. El profe con experiencia tiene el sistema para profesionalizarse.'
  }, {
    q: '¿Los 6 Bonus están en las dos opciones?',
    a: 'Sí. Los 6 Bonus están incluidos en el Pack Profesional y en el Megapack Élite. La diferencia son los 2 Ebooks Élite exclusivos del Megapack.'
  }, {
    q: '¿Qué diferencia hay con otros materiales que ya existen?',
    a: 'Gimnasia Artística 360 es el único sistema en Argentina con 52 semanas de planificación completa, por nivel, con progresiones técnicas, planillas de evaluación y herramientas de competencia en un solo lugar.'
  }, {
    q: '¿Sirve para niveles mezclados en el mismo grupo?',
    a: 'Sí. Cada tomo incluye progresiones diferenciadas para grupos heterogéneos. El Nivelómetro 360 te ayuda a ubicar a cada alumna en su nivel real.'
  }, {
    q: '¿Qué pasa si no me sirve?',
    a: 'Garantía de 7 días sin preguntas. 100% de devolución. Sin formularios.'
  }, {
    q: '¿Vale la pena el Megapack Élite si ya planifico bien mis clases?',
    a: 'Si ya planificás bien, los Ebooks Élite te llevan al siguiente nivel: limpiar la ejecución para ganar torneos y destrabar alumnas estancadas. Eso no lo da ningún otro material del mercado argentino.'
  }, {
    q: '¿Puedo pagar con tarjeta de crédito?',
    a: 'Sí. Tarjeta de crédito, débito, transferencia bancaria y Mercado Pago.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-20 bg-slate-50" data-id="element-76">
      <div className="max-w-3xl mx-auto px-4" data-id="element-77">
        <h2 className="text-3xl font-extrabold text-center text-gray-900 mb-12" data-id="element-78">
          Preguntas Frecuentes
        </h2>

        <div className="space-y-4" data-id="element-79">
          {faqs.map((faq, i) => <div key={i} className="bg-white border border-gray-200 rounded-xl overflow-hidden" data-id="element-80">
              <button className="w-full text-left px-6 py-4 flex items-center justify-between font-bold text-gray-900 hover:bg-gray-50 transition-colors" onClick={() => setOpenIndex(openIndex === i ? null : i)} data-id="element-81">
                <span data-id="element-82">{faq.q}</span>
                <ChevronDown className={`w-5 h-5 text-gray-500 transition-transform ${openIndex === i ? 'rotate-180' : ''}`} data-id="element-83" />
              </button>

              {openIndex === i && <div className="px-6 pb-4 text-gray-600 text-sm leading-relaxed" data-id="element-84">
                  {faq.a}
                </div>}
            </div>)}
        </div>
      </div>
    </section>;
}